import { Component } from '@angular/core';
import { VeerBrandLogoComponent } from '../../common/components/veer-brand-logo';

@Component({
    standalone: true,
    selector: 'app-footer',
    imports: [VeerBrandLogoComponent],
    template: `<div class="layout-footer flex items-center justify-center gap-2">
        <app-veer-brand-logo variant="mark" size="sm" />
        <span class="font-medium">Copyright © {{currentYear}} | Veer Solutions</span>
    </div>`
})
export class AppFooter {
  currentYear: number = new Date().getFullYear();
}
